import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
// import removed: ScrollArea was replaced with native overflow container
import { PolicyConfigurationForm } from './PolicyConfigurationForm';
import { useLeavePolicyMutations } from '@/hooks/leave';
import type { CreateLeavePolicyInput } from '@/services/leave/leavePolicyTypes';

interface CreatePolicyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CreatePolicyDialog({ open, onOpenChange }: CreatePolicyDialogProps) {
  const [formData, setFormData] = useState<Partial<CreateLeavePolicyInput>>({});
  const { createLeavePolicy } = useLeavePolicyMutations();

  const handleSave = async (data: CreateLeavePolicyInput) => {
    try {
      await createLeavePolicy.mutateAsync(data);
      onOpenChange(false);
      setFormData({});
    } catch (error) {
      // Error is handled by the mutation
      console.error('Failed to create policy:', error);
    }
  };

  const handleCancel = () => {
    setFormData({});
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>Create New Leave Policy</DialogTitle>
          <DialogDescription>
            Configure a new leave policy for your organization. You can set accrual rules, 
            balance limits, and approval workflows.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[70vh] pr-4 overflow-y-auto">
          <PolicyConfigurationForm
            initialData={formData}
            onSave={handleSave}
            onCancel={handleCancel}
            isLoading={createLeavePolicy.isPending}
            mode="create"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}